import { ICreatePickupRequest, IEditPickupRequestPayload, IGetPickupRequestList, IPickupRequestDetails, IPickupRequestListSearch } from "../../../types/operations/pickupRequestInterface";
import { PickupRequestActionTypes, PickupRequestActions } from "../../actionTypes/operations/pickupRequestTypes";

export const createPickupRequest = (payload: ICreatePickupRequest): PickupRequestActionTypes => ({
  type: PickupRequestActions.CREATE_PICKUP_REQUEST,
  payload
})

export const getPickupRequestList = (payload: IPickupRequestListSearch): PickupRequestActionTypes => ({
  type: PickupRequestActions.GET_PICKUP_REQUEST_LIST,
  payload
});

export const setPickupRequestList = (payload: Array<IGetPickupRequestList>): PickupRequestActionTypes => ({
  type: PickupRequestActions.SET_PICKUP_REQUEST_LIST,
  payload
})

export const setPickupRequestListCount = (payload: number): PickupRequestActionTypes => ({
  type: PickupRequestActions.SET_PICKUP_REQUEST_PAGE_COUNT,
  payload
})

export const getPickupRequestDataById = (id: string): PickupRequestActionTypes => ({
  type: PickupRequestActions.GET_PICKUP_REQUEST_DATA_BY_ID,
  payload: id
})

export const setPickupRequestDataById = (payload: IPickupRequestDetails) => ({
  type: PickupRequestActions.SET_PICKUP_REQUEST_DATA_BY_ID,
  payload
})

export const editPickupRequest = (payload: IEditPickupRequestPayload) => ({
  type: PickupRequestActions.EDIT_PICKUP_REQUEST_DATA_BY_ID,
  payload,
});